import { createFeatureSelector, createSelector } from '@ngrx/store';
import { StudyDataState } from '../../../reducers';

export const selectStudyDataState = createFeatureSelector<StudyDataState>('selectedStudy');

export const selectSlideOutData = createSelector(selectStudyDataState, (data) => data.slideOut);

export const selectCompanySlideOutData = createSelector(selectSlideOutData, (slideOut) => slideOut.companySlideOut);

export const selectActiveTabIndex = createSelector(selectCompanySlideOutData, (data) => data.activeTabIndex);
